//#region src/modules/Records/utils/getDefaultRecordImageUrl.ts
var getDefaultRecordImageUrl = (recordType, size) => {
	let baseUrl;
	if (recordType === "item") baseUrl = "https://therms.s3.us-west-2.amazonaws.com/images/record-property-placeholder.png";
	if (recordType === "vehicle") baseUrl = "https://therms.s3.us-west-2.amazonaws.com/images/record-vehicle-placeholder.png";
	baseUrl = "https://therms.s3.us-west-2.amazonaws.com/images/record-person-placeholder.png";
	if (size === "small") return baseUrl.concat(".small");
	if (size === "thumbnail") return baseUrl.concat(".thumbnail");
	return baseUrl;
};
//#endregion
export { getDefaultRecordImageUrl };

//# sourceMappingURL=getDefaultRecordImageUrl.js.map